import {
  Avatar,
  Card,
  ListItem,
  ListItemAvatar,
  ListItemText
} from "@material-ui/core"
import moment from "moment"
import React from "react"

interface NotificationType {
  data: {
    text: string
  }
  created_at: string
}

type NotificationProps = {
  notification: NotificationType
}

export default function Notification(props: NotificationProps) {
  const { notification } = props

  const createdAt = moment(notification.created_at)

  const date = () => {
    if (createdAt.isSame(moment(), "day")) return "Today"
    if (createdAt.isSame(moment().subtract(1, "days"), "day"))
      return "Yesterday"

    return createdAt.format("D MMM YYYY")
  }

  const time = createdAt.format("HH:mm")

  const secondary = date() + " at " + time

  return (
    <Card>
      <ListItem>
        <ListItemAvatar>
          <Avatar />
        </ListItemAvatar>
        <ListItemText primary={notification.data.text} secondary={secondary} />
      </ListItem>
    </Card>
  )
}
